module.exports = __webpack_public_path__ + "fonts/Clash-Bold.6824b1e.otf";